import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import logo from "./logo.png";
// import { AiOutlineMenu, AiOutlineMenuFold } from "react-icons/Ai";
import { MenuLink, MobileMainMenu, SiteLogo } from "./styles";
import styled from "@emotion/styled";

const Logo = styled.div`
  width: 80%;
`;
const Links = styled.a``;

export default function MobileMenu(props) {
  const [state, setState] = React.useState({ top: false });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };

  return (
    <MobileMainMenu>
      <React.Fragment>
        <Links href="/">
          <Logo>
            <SiteLogo src={logo} />
          </Logo>
        </Links>
        <Button onClick={toggleDrawer("left", true)}>
          {state["left"] ? (
            <span
              className="material-symbols-outlined"
              // style={{ color: "#ffffff", fontSize: "40px" }}
            >
              {/* <AiOutlineMenuFold /> */}
            </span>
          ) : (
            <span
              className="material-symbols-outlined"
              // style={{ color: "#ffffff", fontSize: "30px" }}
            >
              {/* <AiOutlineMenu /> */}
            </span>
          )}
        </Button>
        <Drawer
          anchor="left"
          open={state["left"]}
          onClose={toggleDrawer("left", false)}
        >
          <Box
            sx={{
              width: 950,
              background: "#000000",
              minHeight: "calc( 100vh - 0px )",
              textAlign: "center",
              paddingTop: "90px",
            }}
            role="presentation"
            onClick={toggleDrawer("left", false)}
            onKeyDown={toggleDrawer("left", false)}
          >
            <Divider />
            <List>
              {props.menuList.map((text, index) => (
                <MenuLink
                  key={index}
                  href={text[1]}
                  className={text[3] + " d-block"}
                >
                  {text[0]}
                </MenuLink>
              ))}
            </List>
          </Box>
        </Drawer>
      </React.Fragment>
    </MobileMainMenu>
  );
}
